import contentfulLight from '@images/logos/contentful-light.png'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import type ContentfulClient from 'teacher-ui-client/services/contentful-client'
import { t } from 'ember-intl'

interface Signature {
  Element: HTMLAnchorElement
  Args: {
    entryId?: string
    assetId?: string
  }
}

export class ContentfulEdit extends Component<Signature> {
  @service contentfulClient!: ContentfulClient

  get contentfulLightPng() {
    return contentfulLight
  }

  get showLink() {
    return this.contentfulClient.showEditLinks && this.href
  }

  get href() {
    const { space, environment } = this.contentfulClient.clientConfig
    const { entryId, assetId } = this.args

    const base = `https://app.contentful.com/spaces/${space}/environments/${environment}`
    if (entryId) {
      return `${base}/entries/${entryId}`
    } else if (assetId) {
      return `${base}/assets/${assetId}`
    }
    return false
  }

  <template>
    {{#if this.showLink}}
      <a href={{this.href}} target="_blank" rel="noopener noreferrer" ...attributes>
        <img
          alt={{t "contentful.edit.logoAlt"}}
          class="hover:grayscale hover:filter"
          src={{this.contentfulLightPng}}
          width="12"
          height="12"
        />
      </a>
    {{/if}}
  </template>
}

export default ContentfulEdit
